import { Component } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ReusableStreamProperty } from '@ipreo/muni-shared';
import { GameDayRootReducerState } from '../../../state/root.state';
import { SetSearchBy } from '../../../state/data/actions';
import { AccountManager } from '../../../state/data/state';
import { getAccountsManagers } from './search-by-account-manager.calculations';
import { getDealWithOrdersState } from '../../../state/data/reducer';
import { GameDayModel } from '../../../models/gameday-model';

@Component({
  selector: 'muni-gameday-search-by-account-manager',
  templateUrl: './search-by-account-manager.template.html',
  styleUrls: ['./search-by-account-manager.styles.scss']
})
export class SearchByAccountManagerComponent {
  @ReusableStreamProperty
  public readonly accountManagerList: Observable<
    AccountManager[]
  > = this.store.pipe(
    select(getDealWithOrdersState),
    filter(({ deal, orders }: GameDayModel.RawData) => !!(deal && orders)),
    map(getAccountsManagers),
    filter((list: AccountManager[]) => list.length > 0)
  );

  constructor(private store: Store<GameDayRootReducerState>) {}

  public suggesterOnSelect([event]: AccountManager[]): void {
    this.store.dispatch(new SetSearchBy(event));
  }
}
